import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DimensionUnits, WeightUnits } from '../../../../enums/enum';
import { ProductLiteResponseModel } from '../../../../../modules/products-catalog/models/response-models/product-response.model';
import { TpmItemsProcessorService } from '../../../../services/tpm-items-processor.service';

@Component({
  selector: 'app-update-item-attritubes',
  standalone: false,
  templateUrl: './update-item-attritubes.component.html',
  styleUrl: './update-item-attritubes.component.css',
})
export class UpdateItemAttritubesComponent {
  @Input() showMissingAttributesModal: boolean = false;
  @Input() products: ProductLiteResponseModel[] = [];
  @Output() productsUpdated = new EventEmitter<ProductLiteResponseModel[]>(); // parent gets notified
  @ViewChild('updateProductOffcanvas') offcanvasRef!: ElementRef<HTMLDivElement>;
  weightUnits = WeightUnits;
  dimensionUnits = DimensionUnits;
  weightUnitKeys: (keyof typeof WeightUnits)[] = [];
  dimensionUnitKeys: (keyof typeof DimensionUnits)[] = [];

  constructor(
    private readonly router: Router,
    private readonly tpmItemsProcessorService: TpmItemsProcessorService,
  ) {
    this.weightUnitKeys = Object.keys(WeightUnits).filter(
      (key) => isNaN(Number(key)) && WeightUnits[key as keyof typeof WeightUnits] !== 0,
    ) as (keyof typeof WeightUnits)[];
    this.dimensionUnitKeys = Object.keys(DimensionUnits).filter(
      (key) => isNaN(Number(key)) && DimensionUnits[key as keyof typeof DimensionUnits] !== 0,
    ) as (keyof typeof DimensionUnits)[];
  }

  getShortProductName(productName: string | null | undefined): string {
    return this.tpmItemsProcessorService.extractProductName(productName ?? '');
  }

  onCancel(): void {
    this.showMissingAttributesModal = false;
    this.router.navigate(['/work-items']);
  }

  onUpdate() {
    this.showMissingAttributesModal = !this.showMissingAttributesModal;
  }
  
  onProductUpdate() {
    this.productsUpdated.emit(this.products);
  }

  onInputChange(product: ProductLiteResponseModel, field: keyof ProductLiteResponseModel, value: any): void {
    (product as any)[field] = value;
    product.isUpdated = true;
  }

  isAllProductsValid(): boolean {
    return this.products.every(
      (p) =>
        !!p.height &&
        !!p.width &&
        !!p.length &&
        !!p.weight &&
        p.dimensionUnit !== DimensionUnits.Unknown &&
        p.weightUnit !== WeightUnits.Unknown,
    );
  }
}
